goog.provide("shadow.js.shim.module$src$svg$type$adset_channel$youtube_svg$default");
shadow.js.shim.module$src$svg$type$adset_channel$youtube_svg$default = shadow.js.shim.module$src$svg$type$adset_channel$youtube_svg.default;
